export const START = 'start';
export const INFORMATIVE = 'informative';
export const ELIGIBILITY = 'eligibility';
export const RESULT = 'result';
export const CHECKING_ELIGIBILITY = 'checking-eligibility';
export const DEFAULT_SCREEN = 'default';
